import styled from 'styled-components'
import { primary } from '@shiphero/ui/UIProvider/colors'

export const Header = styled.header`
  width: 100%;
  height: 44px;
  display: flex;
  padding: 0 15px;
  align-items: center;
  background-color: #2a3b51;
  justify-content: space-between;

  span {
    color: white;
    font-size: 12px;
    cursor: default;
    user-select: none;
  }
`

export const Section = styled.section`
  display: flex;
  padding-top: 35px;
  text-align: center;
  align-items: center;
  flex-direction: column;
  border-top: 1px solid #eff2f7;

  img {
    user-select: none;
  }

  p {
    color: #263445;
    font-size: 20px;
    padding: 20px 0;
    cursor: default;
    user-select: none;
  }
`

export const Computer = styled.section`
  display: flex;
  height: 120px;
  margin: 0 20px;
  cursor: default;
  user-select: none;
  flex-direction: column;
  justify-content: center;

  h1 {
    margin-top: 0;
    font-size: 18px;
  }

  a {
    cursor: pointer;
    color: ${primary.hero};
  }
`

export const Name = styled.div`
  color: #2c9ff3;
  cursor: pointer;
  font-size: 20px;
  height: 35px;
  padding: 7.5px 0;
`

export const Form = styled.form`
  display: flex;
  justify-content: space-between;
  align-items: center;

  [data-ui='Input'] {
    flex-grow: 1;
    input {
      min-width: unset;
    }
  }

  [data-ui='Button'] {
    min-width: unset;
  }

  > * {
    margin: 0 4px;
  }
`
